export default "__VITE_ASSET__BcATniwU__"